// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Link, useParams } from "react-router-dom";
import { ROUTE_DEFINITIONS, getPath } from "routes/routes";

import React from "react";
import { TestRunParams } from "./TestRunConstants";
import { useTestRunConfig } from "./useTestRunConfig";

interface TestRunConfigProps {
  nav: string;
}

const TestRunStepLink: React.FunctionComponent<TestRunConfigProps> = props => {
  const { step, testRunUID } = useParams<TestRunParams>();

  const { getTestRunStep } = useTestRunConfig();
  const currentStepDefinition = getTestRunStep(step);
  if (
    !currentStepDefinition.nav.next ||
    !currentStepDefinition.nav.next![props.nav]
  ) {
    throw new Error(`step ${step} doesn't define a next nav ${props.nav}`);
  }

  const targetStepName = currentStepDefinition.nav.next![props.nav];

  const path = getPath(ROUTE_DEFINITIONS.PERFORMTEST, {
    params: {
      ":testRunUID": testRunUID,
      ":step": targetStepName!,
    },
  });

  return (
    <Link {...props} to={path}>
      {props.children}
    </Link>
  );
};

export default TestRunStepLink;
